let rtlScrollType;

function getRtlScrollType() {
  if (rtlScrollType) return rtlScrollType;
  if (!document.body) return 'default';

  const div = document.createElement('div');
  div.dir = 'rtl';
  div.style.width = '50px';
  div.style.height = '50px';
  div.style.overflow = 'scroll';
  div.style.position = 'absolute';
  div.style.top = '-9999px';

  const inner = document.createElement('div');
  inner.style.width = '100px';
  inner.style.height = '50px';
  div.appendChild(inner);
  document.body.appendChild(div);

  if (div.scrollLeft > 0) {
    rtlScrollType = 'default';
  } else {
    div.scrollLeft = 1;
    rtlScrollType = div.scrollLeft === 0 ? 'negative' : 'reverse';
  }

  document.body.removeChild(div);
  return rtlScrollType;
}

function setNormalizedScrollLeft(element, normalizedLeft) {
  if (document.documentElement.getAttribute('dir') !== 'rtl') {
    element.scrollTo({ left: normalizedLeft });
    return;
  }

  const max = element.scrollWidth - element.clientWidth;
  const clamped = Math.max(0, Math.min(normalizedLeft, max));

  let actualLeft = clamped;
  switch (getRtlScrollType()) {
    case 'negative':
      actualLeft = -clamped;
      break;
    case 'reverse':
      actualLeft = max - clamped;
      break;
  }

  element.scrollTo({ left: actualLeft });
}

if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        setNormalizedScrollLeft(container, (activeMedia.width - container.clientWidth) / 2);

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
